import { CommonError } from '../../types';
import {
    PROFILE_CHANGE_PASSWORD_DATA,
    PROFILE_CHANGE_PASSWORD_ERROR,
    PROFILE_CHANGE_PASSWORD_FETCH,
    PROFILE_CHANGE_USER_DATA,
    PROFILE_CHANGE_USER_ERROR,
    PROFILE_CHANGE_USER_FETCH,
    PROFILE_CHANGE_USER_LEVEL,
    PROFILE_RESET_USER,
    PROFILE_USER_DATA,
    PROFILE_USER_ERROR,
    PROFILE_USER_FETCH,
} from './constants';
import { User } from './types';

export interface ChangePasswordFetch {
    type: typeof PROFILE_CHANGE_PASSWORD_FETCH;
    payload: {
        oldPassword: string;
        newPassword: string;
    };
}

export interface ChangePasswordData {
    type: typeof PROFILE_CHANGE_PASSWORD_DATA;
}

export interface ChangePasswordError {
    type: typeof PROFILE_CHANGE_PASSWORD_ERROR;
    error: CommonError;
}

export interface UserFetch {
    type: typeof PROFILE_USER_FETCH;
}

export interface UserInfo {
    type: typeof PROFILE_USER_DATA;
    payload: {
        user: User;
    };
}

export interface UserError {
    type: typeof PROFILE_USER_ERROR;
    error: CommonError;
}

export interface UserReset {
    type: typeof PROFILE_RESET_USER;
}

export interface ChangeUserLevel {
    type: typeof PROFILE_CHANGE_USER_LEVEL;
    payload: {
        level: number;
    };
}

export interface ChangeUserDataFetch {
    type: typeof PROFILE_CHANGE_USER_FETCH;
    payload: {
        user: User;
    };
}

export interface ChangeUserData {
    type: typeof PROFILE_CHANGE_USER_DATA;
    payload: {
        user: User;
    };
}

export interface ChangeUserDataError {
    type: typeof PROFILE_CHANGE_USER_ERROR;
    error: CommonError;
}

export type ProfileAction =
    | ChangePasswordFetch
    | ChangePasswordData
    | ChangePasswordError
    | UserFetch
    | UserInfo
    | UserError
    | UserReset
    | ChangeUserLevel
    | ChangeUserDataFetch
    | ChangeUserData
    | ChangeUserDataError;

export const changePasswordFetch = (payload: ChangePasswordFetch['payload']): ChangePasswordFetch => ({
    type: PROFILE_CHANGE_PASSWORD_FETCH,
    payload,
});

export const changePasswordData = (): ChangePasswordData => ({
    type: PROFILE_CHANGE_PASSWORD_DATA,
});

export const changePasswordError = (error: CommonError): ChangePasswordError => ({
    type: PROFILE_CHANGE_PASSWORD_ERROR,
    error,
});

export const userFetch = (): UserFetch => ({
    type: PROFILE_USER_FETCH,
});

export const userData = (payload: UserInfo['payload']): UserInfo => ({
    type: PROFILE_USER_DATA,
    payload,
});

export const userError = (error: CommonError): UserError => ({
    type: PROFILE_USER_ERROR,
    error,
});

export const userReset = (): UserReset => ({
    type: PROFILE_RESET_USER,
});

export const changeUserLevel = (payload: ChangeUserLevel['payload']): ChangeUserLevel => ({
    type: PROFILE_CHANGE_USER_LEVEL,
    payload,
});

export const changeUserDataFetch = (payload: ChangeUserDataFetch['payload']): ChangeUserDataFetch => ({
    type: PROFILE_CHANGE_USER_FETCH,
    payload,
});

export const changeUserData = (payload: ChangeUserData['payload']): ChangeUserData => ({
    type: PROFILE_CHANGE_USER_DATA,
    payload,
});

export const changeUserDataError = (error: CommonError): ChangeUserDataError => ({
    type: PROFILE_CHANGE_USER_ERROR,
    error,
});
